import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { MessageCircle, CalendarCheck } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const FloatingCTAs = () => {
  const { t, openBooking, openWhatsApp } = useSite();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      {/* Desktop floating WhatsApp */}
      <motion.button
        onClick={() => openWhatsApp()}
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: show ? 1 : 0, scale: show ? 1 : 0.8 }}
        transition={{ duration: 0.3 }}
        className="hidden md:flex fixed bottom-6 right-6 z-[60] items-center gap-3 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3.5 shadow-[0_10px_30px_rgba(37,211,102,0.4)] hover:brightness-110 transition-[filter]"
        data-testid="float-whatsapp"
      >
        <MessageCircle size={22} />
        <span className="font-sans font-medium text-sm">{t.wa.desktop}</span>
      </motion.button>

      {/* Mobile bottom persistent CTA */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-[60] grid grid-cols-2 gap-px bg-navy/10 border-t border-navy/10 backdrop-blur-xl" data-testid="mobile-cta">
        <button onClick={() => openBooking()}
          className="flex items-center justify-center gap-2 bg-navy text-white py-4 font-sans font-medium text-sm"
          data-testid="mcta-book">
          <CalendarCheck size={18} /> {t.mobileCta.book}
        </button>
        <button onClick={() => openWhatsApp()}
          className="flex items-center justify-center gap-2 bg-[#25D366] text-white py-4 font-sans font-medium text-sm"
          data-testid="mcta-wa">
          <MessageCircle size={18} /> {t.mobileCta.wa}
        </button>
      </div>
    </>
  );
};

export default FloatingCTAs;
